<template>

  <div class="v-switch">

  <label class="switch">
    <input type="checkbox"
      :checked="modelValue === trueValue"
      @change="$emit('change', $event.target.checked ? trueValue : falseValue)">
    <span class="slider round"></span>
  </label>
  <span class="label">{{label}}</span>

  </div>

</template>

<script>
export default{
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {

    modelValue: {
      default: false
    },

    label: {
      required: true,
      type: String
    },

    trueValue: {
      default: true
    },

    falseValue: {
      default: false
    }

  },

  data: function(){

    return {

    }

  },

  methods: {



  }

}
</script>

<style scoped>
.v-switch{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.v-switch span.label{
  margin-left: 10px;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 26px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: pointer;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  top: 50%;
  /* left: 4px; */
  /* bottom: 4px; */
  background-color: white;
  transform: translate(4px, -50%);
  transition: .4s;
}

input:checked + .slider {
  background-color: var(--green);
}

input:focus + .slider {
  box-shadow: 0 0 1px var(--green);
}

input:checked + .slider:before {
  transform: translate(38px, -50%);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
